<template>
    <div>
        <public-header title="战区管理"></public-header>
        <ak-model-filter-card model="warZone" @search="search" @reset="reset" />
        <div class="myCard">
            <ak-model-card model="warZone" ref="warZone" :page.sync="page" :filters="filters" tableSize="small"/>
        </div>
    </div>
  </template>
<script>

import publicHeader from '../../components/publicHeader.vue'

export default {
  components: {
    publicHeader
  },
  data () {
    return {
      filters: {
        parentNode: {
          $exists: false
        }
      },
      page: Number(this.$route.query.page) || 1
    }
  },
  watch: {
    page (val) {
      this.$router.replace({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, { page: this.page })
      })
    }
  },
  mounted () {
  },
  methods: {
    search (filters) {
      this.page = 1
      this.filters = {
        parentNode: {
          $exists: false
        }
      }
      this.filters = { ...this.filters, ...filters }
    },
    reset () {
      this.page = 1
      this.filters = {
        parentNode: {
          $exists: false
        }
      }
    }
  }
}
</script>
  <style lang="scss" scoped>
  .myTab {
    padding: 24px 0 0 24px;
  }
  </style>
